import { render, staticRenderFns } from "./timelog-chart-week.vue?vue&type=template&id=a3133d10&"
import script from "./timelog-chart-week.vue?vue&type=script&lang=js&"
export * from "./timelog-chart-week.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports